const groupPrefix: string = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, 'promotions', 'generate-report')

export const apiMarketingPromotions = {
	downloadPromotionReport: async (): Promise<void> => {
		const response = (await apiCommonRaw<BlobPart>(`${groupPrefix}`, {
			method: 'POST',
			body: {
				report_type: 'foodpack',
				report_date: dateToFilterFormat(new Date()),
			},
			responseType: 'blob',
		})) as unknown as IApiCommonRawModel<BlobPart>

		downloadFileFromResponse(response, 'promotion-report.xlsx')
	},
}
